import axios from "axios";
import { API_URL } from '../api.js'

const api = `${API_URL}/restaurant`

export default {
  async isNameAvailable(nameType, nameValue) {
    const resp = await axios.get(`${api}/isnameavailable?nameType=${nameType}&nameValue=${nameValue}`);
    return resp.data;
  },
  async createRestaurant(restaurant) {
    const resp = await axios.post(`${api}/create`, restaurant);
    return resp.data;
  },
  async getRestaurant(restaurantId, pick) {
    if (pick) {
      const resp = await axios.get(
        `${api}/${restaurantId}?pick=${pick}`
      );
      return resp.data;
    } else {
      const resp = await axios.get(
        `${api}/${restaurantId}`
      );
      return resp.data;
    }
  },
  async addCategory(restaurantId, category) {
    const resp = await axios.post(`${api}/addcategory`, {
      restaurantId,
      category
    });
    return resp.data;
  },
  async editCategory(restaurantId, category) {
    const resp = await axios.post(`${api}/editcategory`, {
      restaurantId,
      category
    });
    return resp.data;
  },
  async removeCategory(restaurantId, categoryId) {
    const resp = await axios.post(`${api}/removecategory`, {
      restaurantId,
      categoryId
    });
    return resp.data;
  },
  async addDish(restaurantId, dish) {
    const resp = await axios.post(`${api}/adddish`, {
      restaurantId,
      dish
    });
    return resp.data;
  },
  async editDish(restaurantId, dish) {
    const resp = await axios.post(`${api}/editdish`, {
      restaurantId,
      dish
    });
    return resp.data;
  },
  async removeDish(restaurantId, dishId) {
    const resp = await axios.post(`${api}/removedish`, {
      restaurantId,
      dishId
    });
    return resp.data;
  },
  async removeDishes(restaurantId, dishIds) {
    const resp = await axios.post(`${api}/removedishes`, {
      restaurantId,
      dishIds
    });
    return resp.data;
  },
  async addDailyMenuDish(restaurantId, dish) {
    const resp = await axios.post(`${api}/adddailymenudish`, {
      restaurantId,
      dish
    });
    return resp.data;
  },
  async addDailyMenuDishes(restaurantId, dishes) {
    const resp = await axios.post(`${api}/adddailymenudishes`, {
      restaurantId,
      dishes
    });
    return resp.data;
  },
  async editDailyMenuDish(restaurantId, dish) {
    const resp = await axios.post(`${api}/editdailymenudish`, {
      restaurantId,
      dish
    });
    return resp.data;
  },
  async removeDailyMenuDish(restaurantId, dishId) {
    const resp = await axios.post(`${api}/removedailymenudish`, {
      restaurantId,
      dishId
    });
    return resp.data;
  },
  async removeDailyMenuDishes(restaurantId, dishIds) {
    const resp = await axios.post(`${api}/removedailymenudishes`, {
      restaurantId,
      dishIds
    });
    return resp.data;
  },
  async uploadImage(restaurantId, type, dishId, fileName) {
    const resp = await axios.post(`${api}/uploadimage`, {
      restaurantId,
      type,
      dishId,
      fileName
    });
    return resp.data;
  },
  async removeImage(restaurantId, type, dishId, imageUrl) {
    const resp = await axios.post(`${api}/removeimage`, {
      restaurantId,
      type,
      dishId,
      imageUrl
    });
    return resp.data;
  },
  async bulkAction(restaurantId, type, dishIds, field, value) {
    const resp = await axios.post(`${api}/bulkaction`, {
      restaurantId,
      type,
      dishIds,
      field,
      value
    });
    return resp.data;
  },
  async addOption(restaurantId, option) {
    const resp = await axios.post(`${api}/addoption`, {
      restaurantId,
      option
    });
    return resp.data;
  },
  async editOption(restaurantId, option) {
    const resp = await axios.post(`${api}/editoption`, {
      restaurantId,
      option
    });
    return resp.data;
  },
  async removeOption(restaurantId, optionId) {
    const resp = await axios.post(`${api}/removeoption`, {
      restaurantId,
      optionId
    });
    return resp.data;
  },

  // delivery zones
  async addZone(restaurantId, zone) {
    const resp = await axios.post(`${api}/addzone`, {
      restaurantId,
      zone
    });
    return resp.data;
  },
  async editZone(restaurantId, zone) {
    const resp = await axios.post(`${api}/editzone`, {
      restaurantId,
      zone
    });
    return resp.data;
  },
  async removeZone(restaurantId, zoneId) {
    const resp = await axios.post(`${api}/removezone`, {
      restaurantId,
      zoneId
    });
    return resp.data;
  },

  // top up restaurant credit
  async addFunds(restaurantId, amount) {
    const resp = await axios.post(`${api}/addfunds`, {
      restaurantId,
      amount
    });
    return resp.data;
  },
};
